/** XeAgents.ai**/
import { createRoot } from "react-dom/client";
import App from "./App";
import { installBasePath } from "./lib/base-path";
import "./index.css";
import './i18n';

// Under a region prefix (/eu), fetch and WebSocket calls to this site gain it before anything runs
installBasePath();

createRoot(document.getElementById("root")!).render(<App />);
